import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Update.IRequest;
type Response = Api.Core.ProductRefundDocument.Update.IResponse;
type Headers = Api.Core.ProductRefundDocument.Update.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/:productId/:documentId';
export default async function productRefundDocumentUpdateApi(
  productId: number,
  documentId: number,
  body: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { productId, documentId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
